export const setCurrentLang = (lang) => {
    return {
      type: 'SET_CURRENT_LANG',
      payload: lang
    };
  };
  